import React, { Fragment, useState } from 'react';
import Checkbox from '../Checkbox';
import PrivacyPolicy from './PrivacyPolicy';

interface TermsOfUseListProps {
  handleCheckIn: (policy:boolean) => void,
}

const TermsOfUseList = ({
  handleCheckIn,
}:TermsOfUseListProps) => {
  const [ isCheckedAll, setIsCheckedAll ] = useState<boolean>(false);
  const [ isCheckedPrivacy, setIsCheckedPrivacy ] = useState<boolean>(false);
  const [ isCheckedThirdParty, setIsCheckedThirdParty ] = useState<boolean>(false);
  const [ isCheckedLocation, setIsCheckedLocation ] = useState<boolean>(false);
  const [ isCheckedAge, setIsCheckedAge ] = useState<boolean>(false);
  const [ isCheckedMarketing, setIsCheckedMarketing ] = useState<boolean> (false);
  const [ isOpenModalPDFAgreement, setIsOpenModalPDFAgreement ] = useState<boolean> (false);
  const isCheckedRequired = isCheckedPrivacy && isCheckedThirdParty && isCheckedLocation && isCheckedAge;

  const openModalPDFAgreement = () => {
    setIsOpenModalPDFAgreement(true);
  };

  const closeModalPDFAgreement = () => {
    setIsOpenModalPDFAgreement(false);
  };

  const checkAll = () => {
    setIsCheckedAll(!isCheckedAll);
    setIsCheckedPrivacy(!isCheckedAll);
    setIsCheckedThirdParty(!isCheckedAll);
    setIsCheckedLocation(!isCheckedAll);
    setIsCheckedAge(!isCheckedAll);
    setIsCheckedMarketing(!isCheckedAll);
  };

  return (
    <Fragment>
      <span className='terms-of-use-list-title'>
        약관 동의
      </span>
      <span className='terms-of-use-list-description'>
        아래 약관 내용에 동의 후 서비스 이용이 가능합니다.
      </span>
      <div className='all-agree-checkbox-container'>
        <Checkbox isChecked={isCheckedAll} onCheck={checkAll} />
        <span className='all-agree-checkbox-text'>
          전체 동의
        </span>
        <span className='all-agree-checkbox-description'>
          (선택항목 포함)
        </span>
      </div>
      <div className='horizontal-line mt-4 mb-12'></div>
      <div className='agree-checkbox-container'>
        <Checkbox isChecked={isCheckedPrivacy} onCheck={() => setIsCheckedPrivacy(!isCheckedPrivacy)} />
        <span className='agree-checkbox-text'>
          개인정보의 수집·이용에 관한 사항 (필수)
        </span>
        <img className='detail-view' src='../../assets/images/arrow-right.png' alt='' onClick={openModalPDFAgreement} />
      </div>
      <div className='agree-checkbox-container'>
        <Checkbox isChecked={isCheckedThirdParty} onCheck={() => setIsCheckedThirdParty(!isCheckedThirdParty)} />
        <span className='agree-checkbox-text'>
          개인정보의 제3자 제공에 관한 사항 - 회사의 국내 및 해외 체인 호텔 (필수)
        </span>
      </div>
      <div className='agree-checkbox-container'>
        <Checkbox isChecked={isCheckedLocation} onCheck={() => setIsCheckedLocation(!isCheckedLocation)} />
        <span className='agree-checkbox-text'>
          위치기반서비스 이용약관 (필수)
        </span>
      </div>
      <div className='agree-checkbox-container'>
        <Checkbox isChecked={isCheckedAge} onCheck={() => setIsCheckedAge(!isCheckedAge)} />
        <span className='agree-checkbox-text'>
          만 14세 이상 이용 동의 (필수)
        </span>
      </div>
      <div className='agree-checkbox-container'>
        <Checkbox isChecked={isCheckedMarketing} onCheck={() => setIsCheckedMarketing(!isCheckedMarketing)} />
        <span className='agree-checkbox-text'>
          이벤트 및 마케팅 활용 동의 (선택)
        </span>
      </div>
      <button className='confirm-button mt-22' disabled={!isCheckedRequired} onClick={() => handleCheckIn(isCheckedMarketing)}>
        확인
      </button>
      <PrivacyPolicy isOpen={isOpenModalPDFAgreement} onClose={closeModalPDFAgreement}/>
    </Fragment>
  );
};

export default TermsOfUseList;